/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Product card image slider: prev/next arrows scroll the swipe strip by one slide. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pgi-prev], [data-pgi-next]');
    if (!button) {
      return;
    }
    var slider = button.closest('[data-pgi-slider]');
    var track = slider ? slider.querySelector('[data-pgi-track]') : null;
    if (!track) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var slide = track.children[0];
    var distance = slide ? slide.getBoundingClientRect().width : track.clientWidth;
    var direction = button.hasAttribute('data-pgi-next') ? 1 : -1;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  });
  document.querySelectorAll('[data-pgi-track]').forEach(function(track){var slider=track.closest('[data-pgi-slider]');var dotsEl=slider?slider.querySelector('[data-pgi-dots]'):null;if(!dotsEl)return;var dots=dotsEl.querySelectorAll('.pgi-slider__dot');var ticking=false;track.addEventListener('scroll',function(){if(ticking)return;ticking=true;requestAnimationFrame(function(){var i=Math.round(track.scrollLeft/track.clientWidth);i=Math.max(0,Math.min(i,dots.length-1));dots.forEach(function(d,j){d.classList.toggle('is-active',j===i)});ticking=false})},{passive:true})});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* Juler product pages: move the Pretty Product Pages icon badge list (#pretty-product-pages-block) directly under the Juler ADD TO CART button row (.customizer-footer), before the product details. Moves the ACTUAL node (no clone), runs only on jewlr pages (Juler #product-customizer-app present), targets the visible buy column at runtime, re-checks on resize, bounded retries, idempotent, silent if the badge or footer is not found. */
(function () {
  var BADGE_ID = 'pretty-product-pages-block';
  function isVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      try { return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }); } catch (e) {}
    }
    if (el.offsetParent !== null) return true;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function julerRoot() { return document.getElementById('product-customizer-app'); }
  function findVisibleFooter(juler) {
    var footers = juler.querySelectorAll('.customizer-right .customizer-footer');
    for (var i = 0; i < footers.length; i++) { if (isVisible(footers[i])) return footers[i]; }
    return null;
  }
  function relocateJulerBadges() {
    try {
      var juler = julerRoot();
      if (!juler) return false;
      var badges = document.getElementById(BADGE_ID);
      if (!badges) return false;
      var footer = findVisibleFooter(juler);
      if (!footer) return false;
      if (footer.nextElementSibling === badges) return true;
      if (badges.style) badges.style.marginTop = '12px';
      footer.parentNode.insertBefore(badges, footer.nextSibling);
      return true;
    } catch (e) { return false; }
  }
  var _pgiDone = false;
  var _pgiObs = null;
  var _pgiTimer = null;
  function _pgiStop() { if (_pgiObs) { _pgiObs.disconnect(); _pgiObs = null; } if (_pgiTimer) { clearInterval(_pgiTimer); _pgiTimer = null; } }
  function _pgiTry() { if (_pgiDone) return true; if (relocateJulerBadges()) { _pgiDone = true; _pgiStop(); return true; } return false; }
  function scheduleRelocation() {
    if (_pgiTry()) return;
    var attempts = 0;
    _pgiTimer = setInterval(function () { attempts++; if (_pgiTry() || attempts >= 60) _pgiStop(); }, 500);
    if (window.MutationObserver) { _pgiObs = new MutationObserver(function () { _pgiTry(); }); _pgiObs.observe(document.body, { childList: true, subtree: true }); }
    setTimeout(_pgiStop, 45000);
  }
  scheduleRelocation();
  var resizeTimer = null;
  window.addEventListener('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { relocateJulerBadges(); }, 300); });
})();

/* Juler product pages: move the Pretty Product Pages icon badge list (#pretty-product-pages-block) directly under the Juler ADD TO CART button row (.customizer-footer), before the product details. Moves the ACTUAL node (no clone), runs only on jewlr pages (Juler #product-customizer-app present), targets the visible buy column at runtime, re-checks on resize, bounded retries, idempotent, silent if the badge or footer is not found. */
(function () {
  var BADGE_ID = 'pretty-product-pages-block';
  function isVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      try { return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }); } catch (e) {}
    }
    if (el.offsetParent !== null) return true;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function julerRoot() { return document.getElementById('product-customizer-app'); }
  function findVisibleFooter(juler) {
    var footers = juler.querySelectorAll('.customizer-right .customizer-footer');
    for (var i = 0; i < footers.length; i++) { if (isVisible(footers[i])) return footers[i]; }
    return null;
  }
  function relocateJulerBadges() {
    try {
      var juler = julerRoot();
      if (!juler) return false;
      var badges = document.getElementById(BADGE_ID);
      if (!badges) return false;
      var footer = findVisibleFooter(juler);
      if (!footer) return false;
      if (footer.nextElementSibling === badges) return true;
      if (badges.style) badges.style.marginTop = '12px';
      footer.parentNode.insertBefore(badges, footer.nextSibling);
      return true;
    } catch (e) { return false; }
  }
  var _pgiDone = false;
  var _pgiObs = null;
  var _pgiTimer = null;
  function _pgiStop() { if (_pgiObs) { _pgiObs.disconnect(); _pgiObs = null; } if (_pgiTimer) { clearInterval(_pgiTimer); _pgiTimer = null; } }
  function _pgiTry() { if (_pgiDone) return true; if (relocateJulerBadges()) { _pgiDone = true; _pgiStop(); return true; } return false; }
  function scheduleRelocation() {
    if (_pgiTry()) return;
    var attempts = 0;
    _pgiTimer = setInterval(function () { attempts++; if (_pgiTry() || attempts >= 60) _pgiStop(); }, 500);
    if (window.MutationObserver) { _pgiObs = new MutationObserver(function () { _pgiTry(); }); _pgiObs.observe(document.body, { childList: true, subtree: true }); }
    setTimeout(_pgiStop, 45000);
  }
  scheduleRelocation();
  var resizeTimer = null;
  window.addEventListener('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { relocateJulerBadges(); }, 300); });
})();

/* Juler product pages: move the Pretty Product Pages icon badge list (#pretty-product-pages-block) directly under the Juler ADD TO CART button row (.customizer-footer), before the product details. Moves the ACTUAL node (no clone), runs only on jewlr pages (Juler #product-customizer-app present), targets the visible buy column at runtime, re-checks on resize, bounded retries, idempotent, silent if the badge or footer is not found. */
(function () {
  var BADGE_ID = 'pretty-product-pages-block';
  function isVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      try { return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }); } catch (e) {}
    }
    if (el.offsetParent !== null) return true;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function julerRoot() { return document.getElementById('product-customizer-app'); }
  function findVisibleFooter(juler) {
    var footers = juler.querySelectorAll('.customizer-right .customizer-footer');
    for (var i = 0; i < footers.length; i++) { if (isVisible(footers[i])) return footers[i]; }
    return null;
  }
  function relocateJulerBadges() {
    try {
      var juler = julerRoot();
      if (!juler) return false;
      var badges = document.getElementById(BADGE_ID);
      if (!badges) return false;
      var footer = findVisibleFooter(juler);
      if (!footer) return false;
      if (footer.nextElementSibling === badges) return true;
      if (badges.style) badges.style.marginTop = '12px';
      footer.parentNode.insertBefore(badges, footer.nextSibling);
      return true;
    } catch (e) { return false; }
  }
  var _pgiDone = false;
  var _pgiObs = null;
  var _pgiTimer = null;
  function _pgiStop() { if (_pgiObs) { _pgiObs.disconnect(); _pgiObs = null; } if (_pgiTimer) { clearInterval(_pgiTimer); _pgiTimer = null; } }
  function _pgiTry() { if (_pgiDone) return true; if (relocateJulerBadges()) { _pgiDone = true; _pgiStop(); return true; } return false; }
  function scheduleRelocation() {
    if (_pgiTry()) return;
    var attempts = 0;
    _pgiTimer = setInterval(function () { attempts++; if (_pgiTry() || attempts >= 60) _pgiStop(); }, 500);
    if (window.MutationObserver) { _pgiObs = new MutationObserver(function () { _pgiTry(); }); _pgiObs.observe(document.body, { childList: true, subtree: true }); }
    setTimeout(_pgiStop, 45000);
  }
  scheduleRelocation();
  var resizeTimer = null;
  window.addEventListener('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { relocateJulerBadges(); }, 300); });
})();

/* Juler product pages: move the Pretty Product Pages icon badge list (#pretty-product-pages-block) directly under the Juler ADD TO CART button row (.customizer-footer), before the product details. Moves the ACTUAL node (no clone), runs only on jewlr pages (Juler #product-customizer-app present), targets the visible buy column at runtime, re-checks on resize, bounded retries, idempotent, silent if the badge or footer is not found. */
(function () {
  var BADGE_ID = 'pretty-product-pages-block';
  function isVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      try { return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }); } catch (e) {}
    }
    if (el.offsetParent !== null) return true;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function julerRoot() { return document.getElementById('product-customizer-app'); }
  function findVisibleFooter(juler) {
    var footers = juler.querySelectorAll('.customizer-right .customizer-footer');
    for (var i = 0; i < footers.length; i++) { if (isVisible(footers[i])) return footers[i]; }
    return null;
  }
  function relocateJulerBadges() {
    try {
      var juler = julerRoot();
      if (!juler) return false;
      var badges = document.getElementById(BADGE_ID);
      if (!badges) return false;
      var footer = findVisibleFooter(juler);
      if (!footer) return false;
      if (footer.nextElementSibling === badges) return true;
      if (badges.style) badges.style.marginTop = '12px';
      footer.parentNode.insertBefore(badges, footer.nextSibling);
      return true;
    } catch (e) { return false; }
  }
  var _pgiDone = false;
  var _pgiObs = null;
  var _pgiTimer = null;
  function _pgiStop() { if (_pgiObs) { _pgiObs.disconnect(); _pgiObs = null; } if (_pgiTimer) { clearInterval(_pgiTimer); _pgiTimer = null; } }
  function _pgiTry() { if (_pgiDone) return true; if (relocateJulerBadges()) { _pgiDone = true; _pgiStop(); return true; } return false; }
  function scheduleRelocation() {
    if (_pgiTry()) return;
    var attempts = 0;
    _pgiTimer = setInterval(function () { attempts++; if (_pgiTry() || attempts >= 60) _pgiStop(); }, 500);
    if (window.MutationObserver) { _pgiObs = new MutationObserver(function () { _pgiTry(); }); _pgiObs.observe(document.body, { childList: true, subtree: true }); }
    setTimeout(_pgiStop, 45000);
  }
  scheduleRelocation();
  var resizeTimer = null;
  window.addEventListener('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { relocateJulerBadges(); }, 300); });
})();

/* HMG Sticky ATC bar - appended 2026-10-14 */
/* HMG Sticky ATC bar - clean rebuild 2026-10-14 */
/* HMG Sticky ATC bar - final 2026-10-14 */
(function () {
  try {
    if (document.getElementById('hmg-sticky-atc')) return;
    var mainAtc = document.querySelector('[data-add-to-cart]') || document.querySelector('button[name="add"]') || document.querySelector('.add-to-cart-button');
    if (!mainAtc) return;
      if (!document.querySelector('.product__title')) return;
    var productSection = mainAtc.closest('[data-section-type]') || mainAtc.closest('main') || document.body;
    var buyBox = mainAtc;
    var titleEl = productSection.querySelector('.product__title') || document.querySelector('.product__title');
    var title = titleEl ? titleEl.textContent.trim() : document.title.split('\u2013')[0].trim();
    var bar = document.createElement('div');
    bar.id = 'hmg-sticky-atc';
    bar.style.transform = 'translateY(110%)';
    bar.innerHTML = '<div class="hmg-sticky-atc__inner"><div class="hmg-sticky-atc__info"><span class="hmg-sticky-atc__title"></span><span class="hmg-sticky-atc__price"></span></div><button type="button" class="hmg-sticky-atc__btn btn btn--primary btn--solid"><span class="btn__text">Add to cart</span></button></div>';
    document.body.appendChild(bar);
    var barTitle = bar.querySelector('.hmg-sticky-atc__title');
    var barPrice = bar.querySelector('.hmg-sticky-atc__price');
    var barBtn = bar.querySelector('.hmg-sticky-atc__btn');
    if (barTitle) barTitle.textContent = title;
    function readPrice() {
      var p = productSection.querySelector('.product__price') || productSection.querySelector('.price') || document.querySelector('.product__price');
      return p ? p.textContent.trim() : '';
    }
    function syncPrice() { if (barPrice) barPrice.textContent = readPrice(); }
    syncPrice();
    if ('MutationObserver' in window) {
      try {
        var mo = new MutationObserver(function () { syncPrice(); });
        mo.observe(productSection, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
    }
    function getVariantId() {
      var inp = productSection.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
      return inp ? inp.value : null;
    }
    function isDisabled() {
      return mainAtc.disabled || mainAtc.classList.contains('is-disabled') || mainAtc.classList.contains('is-incomplete') || mainAtc.getAttribute('aria-disabled') === 'true';
    }
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var vid = getVariantId();
        if (!vid || isDisabled()) {
          var target = productSection.querySelector('.product__form') || buyBox;
          if (target && target.scrollIntoView) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          return;
        }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) }).then(function () {
          var cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink) { cartLink.click(); } else { window.location.href = '/cart'; }
        }).catch(function () {
          try { mainAtc.click(); } catch (e) { window.location.href = '/cart'; }
        });
      });
    }
    function updateBar() {
      try {
        var r = buyBox.getBoundingClientRect();
        var out = r.bottom < 0;
        bar.style.transform = out ? 'translateY(0)' : 'translateY(110%)';
      } catch (e) {}
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  } catch (e) {}
})();